<form [formGroup]="entityFormGroup" *ngIf="(entityFormGroup != null)">
  <input class="form-control form-control-sm mb-2" #flexboxInput type="text" aria-label="Number"
    [formControlName]="ie.InterfaceElementID" [matAutocomplete]="flex" (blur)="resetFlexbox()" />
  <mat-autocomplete #flex="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
      (onSelectionChange)="filterPostList($event);resetFlexbox()">
      {{option[displayName]}}
    </mat-option>
  </mat-autocomplete>
</form>
<form *ngIf="(entityFormGroup == null)">
  <div class="input-group mb-3">  
    <input class="form-control form-control-sm mb-2" #flexboxInput type="text" aria-label="Number" [formControl]="myControl" [placeholder]="ie.PreLabel.DisplayName"
    [matAutocomplete]="flex" (blur)="resetFlexbox()" />
    <div class="input-group-append">
    <button class="btn btn-secondary btn-sm" type="button" (click)="focusOnPlaceInput()">X</button></div>
    <mat-autocomplete #flex="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
      (onSelectionChange)="filterPostList($event);resetFlexbox()">
      {{option[displayName]}}
    </mat-option>
  </mat-autocomplete>
  </div>
</form>